export default [
  {
    path: '/system',
    name: 'system',
    component: () => import('@/pages'),
    redirect: '/system/users',
    meta: { title: '系统管理', icon: 'setting' },
    children: [
      {
        path: 'users',
        name: 'users',
        component: () => import('@/pages/system/users'),
        meta: { title: '用户管理', icon: 'user', parent: 'system' }
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('@/pages/system/roles'),
        meta: { title: '角色管理', icon: 'team', parent: 'system' }
      },
      {
        path: 'permissions',
        name: 'permissions',
        component: () => import('@/pages/system/permissions'),
        meta: { title: '权限管理', icon: 'solution', parent: 'system' }
      },
      {
        path: 'systemProject',
        name: 'systemProject',
        component: () => import('@/pages/system/project'),
        meta: { title: '项目管理', icon: 'project', parent: 'system' }
      },
      {
        path: 'team',
        name: 'team',
        component: () => import('@/pages/system/team'),
        meta: { title: '团队管理', icon: 'team', parent: 'system' }
      },
      {
        path: 'scheduler',
        name: 'scheduler',
        component: () => import('@/pages/system/scheduler'),
        meta: { title: '定时任务', icon: 'schedule', parent: 'system' }
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('@/pages/system/service'),
        meta: { title: '服务管理', icon: 'cloud-server', parent: 'system' }
      },
      {
        path: 'artifact',
        name: 'artifact',
        component: () => import('@/pages/system/artifact'),
        meta: { title: '制品管理', icon: 'safety-certificate', parent: 'system' }
      },
      {
        path: 'artifactVersion',
        name: 'artifactVersion',
        component: () => import('@/pages/system/artifact/detail'),
        meta: { title: '制品版本', icon: 'cloud-server', parent: 'system', show: false }
      },
      {
        path: 'navigationManage',
        name: 'navigationManage',
        component: () => import('@/pages/system/navigation'),
        meta: { title: '导航管理', icon: 'cloud-server', parent: 'layout' }
      },
      {
        path: 'changelog',
        name: 'changelogs',
        component: () => import('@/pages/system/changelogs'),
        meta: { title: '更新日志', icon: 'calendar', parent: 'system' }
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/pages/system/feedback'),
        meta: { title: '用户反馈', icon: 'form', parent: 'system' }
      }
    ]
  }
];
